import { render, staticRenderFns } from "./InviteToRegister.vue?vue&type=template&id=34f988bc&scoped=true"
import script from "./InviteToRegister.vue?vue&type=script&lang=js"
export * from "./InviteToRegister.vue?vue&type=script&lang=js"
import style0 from "./InviteToRegister.vue?vue&type=style&index=0&id=34f988bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f988bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f988bc')) {
      api.createRecord('34f988bc', component.options)
    } else {
      api.reload('34f988bc', component.options)
    }
    module.hot.accept("./InviteToRegister.vue?vue&type=template&id=34f988bc&scoped=true", function () {
      api.rerender('34f988bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/InviteToRegister.vue"
export default component.exports